import select from './SearchDictItemSelect.vue'
const SearchDictItemSelect = {
  install: function (Vue) {
    Vue.component('SearchDictItemSelect', select)
  }
}
export default SearchDictItemSelect
